const LogoComponent = () => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="relative grid h-full w-full grid-cols-2 grid-rows-2 gap-[8%] shadow-inner">
        <div className="h-full w-full bg-slate-800 text-slate-800"></div>
        <div className="h-full w-full bg-slate-800 text-slate-800"></div>
        <div className="h-full w-full bg-slate-800 text-slate-800"></div>
        <div className="h-full w-full rounded-full bg-orange-600"></div>
      </div>
    </div>
  )
}
export default LogoComponent
